import React, { createContext, useState } from 'react';

// Creating a new context named AppContext
const AppContext = createContext();

// Creating a provider component for the AppContext
export const AppContextProvider = ({ children }) => {
    // Defining a state variable 'loader' and its setter 'setLoader' using useState hook, with initial value 'false'
    const [loader, setLoader] = useState(false);

    // Returning the AppContext.Provider component with 'loader' and 'setLoader' values provided as context
    return (
        <AppContext.Provider value={{ loader, setLoader }}>
            {children} {/* Rendering the children components passed to the provider */}
        </AppContext.Provider>
    );
};

// Exporting the AppContextProvider as named export
export default AppContext;